/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { useFormikContext } from 'formik'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  pluginActivePreset,
  withPluginPreset,
  type PluginEmbedSettings,
} from '@sportninja/common/features/account/apiAccess'
import ChipGroup from 'src/components/ts-components/ChipGroup'
import Text from 'src/components/ts-components/Text'
import { PLUGIN_PRESET_OPTIONS } from '../../constants/pluginSettings'

/**
 * Default unsets the page colours (the plugin's own, so Mode keeps working); a
 * preset sets the header and primary colours and unsets the rest. Optional
 * colours stay.
 */
export const PresetChips = () => {
  const { values, setFieldValue } = useFormikContext<PluginEmbedSettings>()
  const label = capitalizeWords('Presets')

  return (
    <div css={cellStyle}>
      <Text variant='paragraphSmall' weight='regular' color={colors.WHITE}>
        {label}
      </Text>
      <ChipGroup
        ariaLabel={label}
        options={PLUGIN_PRESET_OPTIONS}
        value={pluginActivePreset(values.colours)}
        onChange={(preset) => {
          const next = PLUGIN_PRESET_OPTIONS.find(
            (option) => option.value === preset
          )?.value
          if (!next) {
            return
          }
          setFieldValue('colours', withPluginPreset(values.colours, next))
        }}
      />
    </div>
  )
}

const cellStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`
